import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  components as DefaultSelectComponents,
  MultiValueGenericProps,
} from 'react-select';
import _get from 'lodash/get';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { SelectOption } from '@lib/components/Select/types';
import { getAllOption } from '@lib/enums/form';
import AvatarIcon from '@lib/assets/icons/avatar.svg';

function UserMultiValueContainer({
  children,
  ...props
}: MultiValueGenericProps) {
  const { t } = useTranslation();
  const { data } = props;
  const { label, value, data: optionData } = data as SelectOption;
  const leftImage =
    _get(optionData, 'avatarAttached.urls.small') ||
    _get(optionData, 'avatarAttached.urls.original') ||
    AvatarIcon;
  if (children === null) return children;
  const allOption = getAllOption(t);
  if (value === allOption.value) return allOption.label;
  return (
    // @ts-ignore
    <DefaultSelectComponents.MultiValueContainer {...props}>
      <Chip
        label={label}
        leftImage={leftImage}
        leftImageRounded
        rightIconComponent={_get(children, 1)}
        size={ChipSizes.medium}
        type={ChipTypes.chipGray}
      />
    </DefaultSelectComponents.MultiValueContainer>
  );
}

export default UserMultiValueContainer;
